import React from "react";
import axios from 'axios';

import { store } from "../../redux/store";
import { connect } from "react-redux";
import history from "../../auth/history";
import './../MoneyTransferComponent/Subtransaction.css';
import './../MoneyTransferComponent/MoneyTransfer.css';
import FooterComponet from "../FooterComponent/FooterComponet";
import $ from "jquery";
import moment, { max } from "moment";
import { v4 as uuidv4 } from 'uuid';
import { Link } from "react-router-dom";
import ProgressGif from '../../assests/images/progress.gif';
import ProgressStatic from '../../assests/images/progress.jpg';
import MtFailed from '../../assests/images/mtfailed.png';
import MtSuccess from '../../assests/images/mtsuccess.png';
import MtPartial from '../../assests/images/mtpartial.png';
import HeaderCommon from '../HeaderComponent/HeadeCommon';
import Menu from "../MenuComponent/Menu";
import tokenErrorHandler from "../tokenErrorHandler";
import { setAepsCashWithDrwalReq, setBiometricDtaCaptureStatus, setMerchantAuthIdPayTM, setPayTMAepsSection } from "../../redux/aeps/aeps.action";

const httpClient = axios.create();

class AepsCashWithdrawlDetails extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			phoneNo: this.props.phone,
			moneyTransferFinalStatusCompleted: false,
			finalTransferMessage: '',
			counter: 0,
			exceptionCounter: 0,
			moneyTransferProgress1: '',
			orderRes: '',
			orderResDisplayMsg: '',
			orderResThirdPartyRespMsg: ''
		}
	}


	componentDidMount() {
        store.dispatch(setMerchantAuthIdPayTM(''));
		this.createOrder();
	}

	createOrder() {
		this.setState({
			progress: 'started',
			orderResDisplayMsg: '',
			orderResThirdPartyRespMsg: ''
		})




		var request = this.props.aepsCashWithDrawllReq;
		store.dispatch(setAepsCashWithDrwalReq(request));





		var url = '/api/v1/aeps/order/create';
		// var url = '/api/v1/paysprint/aeps/connector/withdrawal';
		const headers = {
			'Authorization': 'Bearer ' + this.props.token,
			'client-id': this.props.agentInfo.id,
			'role': this.props.clientRole
		}
		httpClient.post(url, request,
			{
				headers,
				timeout: 180 * 1000
			}
		).then((response) => {


			console.log('aeps action response' + JSON.stringify(response.data));

			if (response.data.response.success == true &&
				response.data.response.msg == 'SUCCESS') {
				store.dispatch(setBiometricDtaCaptureStatus(''));
				this.setState({
					progress: 'completed'
				})

				this.setState({
					orderRes: response.data
				})


			} else {

				store.dispatch(setBiometricDtaCaptureStatus(''));

				var msg = '';
				if (response.data.response.tpsRspMsg != null &&
					response.data.response.tpsRspMsg != undefined &&
					response.data.response.tpsRspMsg != '' &&
					response.data.response.tpsRspMsg.trim().includes("response_code")) {

					try {
						var myObj = JSON.parse(response.data.response.tpsRspMsg.trim())
						msg = myObj.message;
						if (msg == undefined) {
							msg = response.data.response.tpsRspMsg;
						}
					}
					catch (err) {
						msg = response.data.response.tpsRspMsg;
					}
				} else {
					msg = response.data.response.tpsRspMsg;
				}
				this.setState({
					progress: 'completed',
					orderRes: response.data,
					orderServiceErrMsg: 'Error-' + response.data.response.displayMsg,
					orderResDisplayMsg: response.data.response.displayMsg,
					orderResThirdPartyRespMsg: msg,
				})


			}
		}).catch(error => {
			this.setState({
				progress: 'completed',
				orderServiceErrMsg: error.message
			})
			store.dispatch(setBiometricDtaCaptureStatus(''));

			console.log(error.message);

			if (error.message.includes("401")) {
				tokenErrorHandler.tokenErrorHandle(error.message, this.props.callBackUrl)
			} else {

			}
		});
	}






	componentWillUnmount() {
	}


	print = (event) => {
		event.preventDefault();
		window.print();
	}

	backToAeps = (event) => {
		event.preventDefault();
		store.dispatch(setPayTMAepsSection('aepsForm'));
		var backaepsbtn1 = document.getElementById('backaepsbtn1');
		backaepsbtn1.click();

	}


	render() {
		return (

			<div>
				<HeaderCommon />
				<Menu />
				<div class="main">
					<div class="right-side">
						<div class="container-fluid">
							<div class="row">
								<div class="col-12">
									<div class="card-b" id="rightdiv">
										<div id="recenttxn">
											<div class="head">
												<h3>AePS CashWithdrawl Details</h3>
												<Link to='/aeps-new'>
													<button type="button" id="backaepsbtn1" hidden={true}></button>
												</Link>

												<button id="backaepsbtn" class="dbbtn" onClick={this.backToAeps}>Back</button>

											</div>

											<div class="benedtls">
												<div class="row">
													<div class="col-12 col-lg-4 order-lg-2">

														{(
															this.state.progress == 'started') ?
															<div class="mtprogess" id="mtrun">
																<img src={ProgressGif} alt="process" class="img-fluid" />
																<h3 class="pending">Transaction in process...Please don't refresh</h3>
															</div>
															:
															this.state.progress == 'completed' &&
																this.state.orderRes != '' &&
																(
																	this.state.orderRes.response.success == true &&
																	this.state.orderRes.response.msg == 'SUCCESS') ?
																<div class="mtprogess" id="mtdone">
																	<img src={MtSuccess} alt="process" class="img-fluid" />
																	<h3 class='success'>Cash Withdrawl successful</h3>
																	<p class='success'>Available Balance : {(this.state.orderRes.optional != null &&
																		this.state.orderRes.optional != '' &&
																		this.state.orderRes.optional != undefined) ?
																		(this.state.orderRes.optional.balanceamount != null &&
																			this.state.orderRes.optional.balanceamount != '' &&
																			this.state.orderRes.optional.balanceamount != undefined) ?
																			this.state.orderRes.optional.balanceamount : 'NA' : 'NA'}</p>
																</div>
																:
																<div class="mtprogess" id="mtfailed">
																	<img src={MtFailed} alt="process" class="img-fluid" />
																	<h3 class="failed">Cash Withdrawl Failed</h3>
																</div>

														}

													</div>
													<div class="col-12 col-md-6 col-lg-4 order-lg-1">
														<div class="graycard">
															<div class="bankdtl">
																{/* <Avatar name={this.props.selectSender.customer.name} round={true} size="44" alt="" /> */}
																<h5>Name</h5>
																<p>{this.props.aepsFullName.toUpperCase()}</p>
															</div>
															<hr />
															<div class="bankdtl">
																<h5>Mobile Number</h5>
																<p>{this.props.aepsMobile}</p>
															</div>

														</div>
													</div>

													<div class="col-12 col-md-6 col-lg-4 order-lg-3">
														<div class="graycard">
															<div class="bankdtl">
																<h5>Retailer Id</h5>
																<p>{this.props.agentInfo.id}</p>
															</div>
															<hr />
															<div class="acntifsc">
																<h5>Retailer Name</h5>
																<p>{this.props.agentInfo.kioskName}</p>
															</div>

															<div class="acntifsc rtxt">
																<h5>Kiosk Code</h5>
																<p>{this.props.agentInfo.kioskCode}</p>
															</div>
														</div>
													</div>
												</div>
											</div>




											{this.state.progress == 'completed' &&
												this.state.orderRes != '' &&
												<div class="subtxn">
													<h4>Sub Transactions</h4>
													{(this.state.orderRes.response.success == true &&
														this.state.orderRes.response.msg == 'SUCCESS') ?
														<div class='subtxn-success'>
															<div class="col-6 col-md-3 col-lg-3 order-md-1">
																<div class="subtxt txnsts">
																	{/* {'Successful '} */}
																	<b>   RRN NO: {(this.state.orderRes.bankId != null) ? this.state.orderRes.bankId : 'NA'}</b></div>
															</div>
															{/* <div class="col-6 col-md-3 col-lg-3 order-md-1">
																<div class="subtxt txnsts">RRN NO: {(this.state.orderRes.bankId!=null && this.state.orderRes.bankId!='')?this.state.orderRes.bankId:''}</div>
															</div> */}

															<div class="row">
																<div class="col-6 col-md-2 col-lg-4 order-md-4">


																	<div class="subtxt subamunt rtxt"> ₹ {parseFloat(this.props.aepsCashWithDrawllReq.transaction.amount)}</div>

																</div>

																<div class="col-12 col-md-4 col-lg-6 order-md-2">
																	<div class="subtxt subid">Txn: {this.state.orderRes.orderId != null ?
																		this.state.orderRes.orderId : 'NA'}</div>
																</div>

																<div class="col-12 col-md-3 col-lg-4 order-md-3">
																	<div class="subtxt">{moment().format('DD-MM-YYYY HH:mm:ss')}</div>
																</div>

															</div>
														</div> :

														<div class='subtxn-failed'>
															<div class="col-6 col-md-3 col-lg-3 order-md-1">
																<div class="subtxt txnsts">
																	{/* {'Failed '} */}
																	<b>   RRN NO: {(this.state.orderRes.bankId != null) ? this.state.orderRes.bankId : 'NA'}</b>
																</div>

															</div>




															<div class="row">
																<div class="col-6 col-md-2 col-lg-6 order-md-4">
																	<div class="subtxt subamunt rtxt">₹ {parseFloat(this.props.aepsCashWithDrawllReq.transaction.amount)}</div>
																</div>

																<div class="col-12 col-md-4 col-lg-4 order-md-2">
																	<div class="subtxt subid"> Txn: {this.state.orderRes.orderId != null ?
																		this.state.orderRes.orderId : 'NA'}</div>
																</div>

																<div class="col-12 col-md-3 col-lg-3 order-md-3">
																	<div class="subtxt">{moment().format('DD-MM-YYYY HH:mm:ss')}</div>
																</div>
															</div>


															<div class="col-12">

																{this.state.orderResDisplayMsg != null &&
																	this.state.orderResDisplayMsg != undefined &&
																	this.state.orderResDisplayMsg != '' &&
																	<div class="subtxt txnsts">
																		<b> Message:{this.state.orderResDisplayMsg}
																		</b>
																	</div>
																}

																{this.state.orderResThirdPartyRespMsg != null &&
																	this.state.orderResThirdPartyRespMsg != undefined &&
																	this.state.orderResThirdPartyRespMsg != '' &&
																	<div class="subtxt txnsts">
																		<b> Third Party Message:{this.state.orderResThirdPartyRespMsg}
																		</b>
																	</div>
																}


															</div>
														</div>
													}
												</div>
											}




											{this.state.progress == 'completed' &&
												this.state.orderRes != '' &&
												<div class="paydtl">
													<div class="row">
														<div class="col-12 col-sm-6">
															<div class="orderdetail">
																<div class="txnhead">Order Details</div>
																<div class="odramt">
																	{/* <p>RRN No <span>{(this.state.orderRes != '' &&
																		this.state.orderRes.bankId != '') ?
																		this.state.orderRes.bankId : 'NA'}</span></p> */}
																	<p>Order Amount <span>₹
																		{parseFloat(this.props.aepsCashWithDrawllReq.transaction.amount).toFixed(2)}</span></p>
																	<p>Commission <span>₹ {parseFloat(this.props.surcharge3).toFixed(2)}</span></p>
																</div>

															</div>
														</div>
														<div class="col-12 col-sm-6">
															<div class="tnsfrdetail">
																<div class="txnhead">Transaction Details</div>
																<div class="odramt">
																	{/* <p>RRN No <span>{(this.state.orderRes != '' &&
																		this.state.orderRes.bankId != '') ?
																		this.state.orderRes.bankId : 'NA'}</span></p> */}
																	<p>Transfer Amount <span>₹ {(
																		this.state.orderRes.response.success == true &&
																		this.state.orderRes.response.msg == 'SUCCESS' &&
																		this.props.transferTotalAmount3 != '' &&
																		this.props.surcharge3 != '')
																		? parseFloat(this.props.aepsCashWithDrawllReq.transaction.amount).toFixed(2)
																		: parseFloat(0).toFixed(2)}</span></p>
																	<p>Commission <span>₹ {(
																		this.state.orderRes.response.success == true &&
																		this.state.orderRes.response.msg == 'SUCCESS' &&
																		this.props.transferTotalAmount3 != '' &&
																		this.props.surcharge != '') ?
																		parseFloat(this.props.surcharge3).toFixed(2) : parseFloat(0).toFixed(2)}</span></p>
																</div>

															</div>
														</div>
													</div>
												</div>
											}


											{/* <div class="txn-btn">
												<button type="button" class="print" onClick={this.print}>Print</button>
												<button type="button" class="help"></button>
											</div> */}


										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>

				<FooterComponet />
			</div>

		);
	}
}


const mapStateToProps = (
	{
		errorMessageReduce: { errorMessage, loginErrorMessage },
		miscReduce: {
			phone,
			agentInfo, token, clientRole, callBackUrl
		}
		, aepsReduce: { aepsCashWithDrawllReq, aepsFullName, aepsMobile, surcharge3, transferTotalAmount3 },

	}

) => ({
	errorMessage, loginErrorMessage, phone,
	agentInfo, token, clientRole, callBackUrl,
	aepsCashWithDrawllReq, aepsFullName, aepsMobile, surcharge3, transferTotalAmount3
});

export default connect(mapStateToProps, null)(AepsCashWithdrawlDetails);


